import React from 'react'

export default class CheckmarkQuestionAnswered extends React.Component {

  render() {
    const {checked} = this.props
    const className = checked ? 'indicator checked' : 'indicator unchecked'

    return (
      <span className={className}></span>
    )
  }
}


// WEBPACK FOOTER //
// ./src/components/CheckmarkQuestionAnswered.js